import Vue from 'vue';
import store from '@/store';
import i18n from '@/plugins/i18n';
import { fetchAccountData } from './startApp';
import { offApp } from './offApp';
import { showAppElements } from './startAppFunctions';

export async function login(credentials) {
  const response = await Vue.prototype.$api.auth[credentials.token ? 'getAuthByToken' : 'login'](credentials);

  if (response.data.payload.sessionOverwrited) {
    Vue.prototype.$notifyInfo(i18n.t('notifications.loggedOutFromOtherDevice'), i18n.t('snotify.infoTitle'));
  }

  const authInfo = response.data.payload;

  setLoginSession(authInfo);
  if (authInfo.accessToken) {
    await fetchAccountData(authInfo.accessToken);
  }
  return authInfo;
}

function setLoginSession(authInfo) {
  localStorage.setItem('token', authInfo.accessToken);
  localStorage.setItem('refreshToken', authInfo.refreshToken);
  localStorage.setItem('sessionId', authInfo.sessionId);
  sessionStorage.setItem('isLoggedIn', 'true');
}

let isWaitingForLogout = false;
export async function logout() {
  console.log('isWaitingForLogout: ', isWaitingForLogout);
  if (isWaitingForLogout) return;

  isWaitingForLogout = true;

  if (store.state.loggedAccount.account?.role === 'CLINIC_ADMIN'
      && store.state.monitoringTime.currentMonitoringPatientId) {
    await store.dispatch('monitoringTime/stopMonitoring');
  }

  try {
    await Vue.prototype.$api.auth.logout({
      accessToken: localStorage.getItem('token'),
      refreshToken: localStorage.getItem('refreshToken'),
      sessionId: localStorage.getItem('sessionId'),
    });
  } catch (e) {
    console.log('logout error:');
    console.dir(e);
    isWaitingForLogout = false;
  }

  showAppElements(false);
  await offApp();
  isWaitingForLogout = false;
}

export async function refreshAccount() {
  const userId = store.state.loggedAccount.account.id;
  const response = await Vue.prototype.$api.accounts.getAccount(userId);
  store.commit('loggedAccount/setAccount', response.data.payload);
}
